import { render, staticRenderFns } from "./DetailList.vue?vue&type=template&id=38b859ad&scoped=true"
import script from "./DetailList.vue?vue&type=script&lang=js"
export * from "./DetailList.vue?vue&type=script&lang=js"
import style0 from "./DetailList.vue?vue&type=style&index=0&id=38b859ad&prod&lang=less&scoped=true"
import style1 from "./DetailList.vue?vue&type=style&index=1&id=38b859ad&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b859ad",
  null
  
)

export default component.exports